import React from 'react';
import PropTypes from 'prop-types';
import ModalInput from 'Modals/components/ModalForm/ModalInput';

class ModalSyncedInput extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      syncedValue: this.props.value,
    };
  }

  handleChange(event) {
    this.setState({
      syncedValue: event.target.value,
    });
  }

  render() {
    const visibleFieldProps = {
      id: this.props.id,
      autoComplete: this.props.autoComplete,
      htmlFor: this.props.htmlFor,
      label: this.props.label,
      name: this.props.name,
      type: this.props.type,
      value: this.state.syncedValue,
      onChange: this.handleChange,
    };
    const visibleField = <ModalInput {...visibleFieldProps} />;

    const hiddenFieldProps = {
      id: this.props.hiddenId,
      htmlFor: this.props.hiddenHtmlFor,
      label: this.props.hiddenLabel,
      name: this.props.hiddenName,
      type: 'hidden',
      value: this.state.syncedValue,
    };
    const hiddenField = <ModalInput {...hiddenFieldProps} />;

    return (
      <div className="modal-synced-input-container">
        {visibleField}
        {hiddenField}
      </div>
    );
  }
}

ModalSyncedInput.defaultProps = {
  autoComplete: true,
  value: '',
};


ModalSyncedInput.propTypes = {
  id: PropTypes.string.isRequired,
  htmlFor: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  value: PropTypes.string,
  autoComplete: PropTypes.bool,
  hiddenId: PropTypes.string.isRequired,
  hiddenHtmlFor: PropTypes.string.isRequired,
  hiddenLabel: PropTypes.string.isRequired,
  hiddenName: PropTypes.string.isRequired,
};

export default ModalSyncedInput;



// WEBPACK FOOTER //
// ./src-react/Modals/components/ModalForm/ModalSyncedInput/index.jsx